import { Component, Input } from '@angular/core';

/** Legend of AttendanceChart, shared by the team and salesperson dashboards. */
@Component({
  selector: 'app-attendance-chart-legend',
  standalone: false,
  templateUrl: './attendance-chart-legend.component.html',
  styleUrl: './attendance-chart-legend.component.scss',
})
export class AttendanceChartLegendComponent {
  @Input() showFormerEmployee = false;
}
